<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="error-logo" [src]="'assets/images/png/error.png'"
           [srcset]="'assets/images/png/error@2x.png 2x, assets/images/png/error@3x.png 3x'" alt="logo"></div>
    <div class="col-12 px-0 d-flex justify-content-center"><label class="service-error-header">
      {{this.textService.keyValueMapping('errorPageHeader', 'Servise Ulaşılamadı', sdkInitTexts)}}
    </label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label class="service-error-message">
      {{this.getErrorText()}}
    </label></div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <pa-redirect></pa-redirect>
    </div>
  </div>
</div>
